import { render } from "./Puzzle.vue?vue&type=template&id=163e77cc"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Puzzle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "163e77cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('163e77cc', __exports__)) {
    api.reload('163e77cc', __exports__)
  }
  
  module.hot.accept("./Puzzle.vue?vue&type=template&id=163e77cc", () => {
    api.rerender('163e77cc', render)
  })

}


export default __exports__